import { LoadablePaint } from '@confluence/loadable';

export const SmartCreateSpaceLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-smartCreateSpace" */ './SmartCreateSpace.tsx'))
			.SmartCreateSpace,
});
